// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg.flip{transform:scaleY(-1)}.flip-icon{transform:rotate(30deg)}@media screen and (max-width: 978px){.ch-header-sub{display:none}}fieldset.radiobutton-group{padding:0}", "",{"version":3,"sources":["webpack://./src/styles/shame.scss"],"names":[],"mappings":"AAEE,SACE,oBAAA,CAIJ,WACE,uBAAA,CAGF,qCACE,eACE,YAAA,CAAA,CAKF,2BACE,SAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
